/*
  Questo file fa la configurazione di i18n per la possibilità della multilingua.
  Quando si va in produzione bisogna mettere il debug a false.
  Documentazione: https://react.i18next.com/
*/

import i18n, { InitOptions } from "i18next";
import Backend from "i18next-chained-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import moment from "moment";
import LocalStorageBackend  from "i18next-localstorage-backend";
import HttpBackend, {  RequestCallback } from "i18next-http-backend";
import LocationRepository from "core/data/LocationRepository";
//import resourcesToBackend from "i18next-resources-to-backend";
import i18next from "i18next";

const cookieLang = document.cookie
	.split("; ")
	.find((x) => x.startsWith("i18next="))
	?.split("=")[1];

export const languageInUse = cookieLang ?? i18n.language ?? "it";

const config: InitOptions = {
	fallbackLng: "it",
	debug: false,
	detection: { order: ["cookie,localStorage"], lookupCookie: "i18next" },
	interpolation: {
		escapeValue: false,
	},
	// supportedLngs: ["it", "en"],
	saveMissingTo: "all",
	ns: ["HSB.App"],
	fallbackNS: "HSB.App",
	saveMissing: true,
	backend: {
		backends: [
			LocalStorageBackend,
			HttpBackend,
			/**
			 *  Effettua il caricamento delle risorse da file compilato,
			 * 	il file compilato deve trovarsi dentro la cartella SRC
			 * 	questo eviterebbe un ulteriore chiamata nel caso in cui il primo metodo
			 * 	dia eccezione o non risponda correttamente
			 */
			//resourcesToBackend((lng: string, ns: string) => import(`../locales/${lng}/${ns}.json`)),
			HttpBackend,
		],
		backendOptions: [
			{
				expirationTime: 24 * 60 * 60 * 1000,
			},
			{
				loadPath: `${window.CONFIG.REACT_APP_WS_MULTILINGUA}/GetLocationsByResourceObject?culture={{lng}}&resourceObject={{ns}}`,
				crossDomain: true,

				request: function (options: any, url: string, payload: {} | string, callback: RequestCallback) {
					if (payload) {
						if (!(typeof payload === "string" || payload instanceof String)) {
							for (var ro in payload) {
								// console.log("Aggiungere '" + ro + "' URL:" + url);
								return callback(null, { status: 200, data: ro });
							}
						} else {
							return callback(null, { status: 200, data: payload.toString() });
						}
					}

					LocationRepository.readFromServiceURL(url)
						.then((res: any) => {
							callback(null, { status: 200, data: res });
						})
						.catch((err: any) => callback(err, { status: 200, data: "" }));
				},
			},
			{
				loadPath: "/locales/{{lng}}/{{ns}}.json",
				addPath: `${window.CONFIG.REACT_APP_WS_MULTILINGUA}/AddLocationHSB?culture={{lng}}&resourceObject={{ns}}`,
			},
		],
	},
	react: {
		transSupportBasicHtmlNodes: true,
		useSuspense: true,
	},
};

i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init(config);

i18n.changeLanguage(languageInUse, () => {
	LocationRepository.getNamespaces(languageInUse).then((res: any) => {
		i18next.loadNamespaces(res);
		i18n.loadLanguages(languageInUse);
	});
});



document.dir = i18n.dir();

moment().locale(i18n.language);

moment.updateLocale("en", {
	longDateFormat: {
		LT: "hh:mm A",
		LTS: "hh:mm:ss A",
		L: "MM/DD/YYYY",
		l: "M/D/YYYY",
		LL: "MMMM Do YYYY",
		ll: "MMM D YYYY",
		LLL: "MMMM Do YYYY LT",
		lll: "MMM D YYYY LT",
		LLLL: "dddd, MMMM Do YYYY LT",
		llll: "ddd, MMM D YYYY LT",
	},
	weekdaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
});


export default i18n;